import React from 'react';
import QuoteForm from './QuoteForm';
import { Mail, Phone, MapPin } from 'lucide-react';
import { BRAND } from '@/data/site';

export default function QuoteSection({ defaultJobType = '' }) {
  return (
    <section className="section-pad bg-ohana-bg" id="quote" data-testid="quote-section">
      <div className="container-ohana">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5">
            <p className="overline">Get a Free Quote</p>
            <h2 className="h-display text-4xl md:text-5xl mt-3 leading-tight">
              Send photos. <br />Get a quote. <br />
              <span className="text-ohana-accent">Done in minutes.</span>
            </h2>
            <p className="mt-6 text-ohana-text-muted text-base md:text-lg leading-relaxed">
              Photo-based quotes are the fastest, most accurate way to price a cleanout. Drop a few pics, hit send, and we'll reply same day with a transparent number.
            </p>

            <div className="mt-8 space-y-4">
              <a
                href={`mailto:${BRAND.email}`}
                className="flex items-center gap-4 rounded-xl border border-ohana-border bg-white p-4 transition hover:border-ohana-accent"
                data-testid="quote-section-email"
              >
                <span className="grid h-11 w-11 place-items-center rounded-lg bg-ohana-primary text-ohana-bg">
                  <Mail className="h-5 w-5" />
                </span>
                <div>
                  <p className="text-xs uppercase tracking-wider text-ohana-text-muted">Email</p>
                  <p className="font-semibold text-ohana-primary">{BRAND.email}</p>
                </div>
              </a>
              <a
                href={`tel:${BRAND.phoneTel}`}
                className="flex items-center gap-4 rounded-xl border border-ohana-border bg-white p-4 transition hover:border-ohana-accent"
                data-testid="quote-section-phone"
              >
                <span className="grid h-11 w-11 place-items-center rounded-lg bg-ohana-primary text-ohana-bg">
                  <Phone className="h-5 w-5" />
                </span>
                <div>
                  <p className="text-xs uppercase tracking-wider text-ohana-text-muted">Call or Text</p>
                  <p className="font-semibold text-ohana-primary">{BRAND.phone}</p>
                </div>
              </a>
              <div className="flex items-center gap-4 rounded-xl border border-ohana-border bg-white p-4">
                <span className="grid h-11 w-11 place-items-center rounded-lg bg-ohana-primary text-ohana-bg">
                  <MapPin className="h-5 w-5" />
                </span>
                <div>
                  <p className="text-xs uppercase tracking-wider text-ohana-text-muted">Service Area</p>
                  <p className="font-semibold text-ohana-primary">{BRAND.serviceArea}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="rounded-3xl border border-ohana-border bg-white p-6 sm:p-8 md:p-10 shadow-xl shadow-ohana-primary/5">
              <QuoteForm defaultJobType={defaultJobType} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
